import { Localized } from "@fluent/react";
import { Box, Button } from "@mui/material";

export const CardActionButtons: React.FC<{ isDefault: boolean; isEditing: boolean; onRestore: () => void; onSave: () => void; onCancel: () => void; onEdit: () => void }> = ({ isDefault, isEditing, onRestore, onSave, onCancel, onEdit }) => (
    <Box display="flex" justifyContent="center" gap={1} mt={2}>
        {isEditing ? (
            <>
                {!isDefault && <Button variant="contained" size="small" color="primary" onClick={onRestore}>
                    <Localized id="company-settings-restore-default">
                        <span>_Przywróć domyślne</span>
                    </Localized>
                </Button>}
                <Button variant="contained" size="small" color="success" onClick={onSave}>
                    <Localized id="save">
                        <span>_save</span>
                    </Localized>
                </Button>
                <Button variant="outlined" size="small" color="secondary" onClick={onCancel}>
                    <Localized id="cancel">
                        <span>_cancel</span>
                    </Localized>
                </Button>
            </>
        ) : (
            <Button variant="contained" size="small" color="primary" onClick={onEdit}>
                <Localized id="edit">
                    <span>_edit</span>
                </Localized>
            </Button>
        )}
    </Box>
);
